import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { LetDirective, PushPipe } from '@ngrx/component';
import { RequestCreateComponent } from './create.component';
import { FuseDateRangeModule } from '@shared/components/date-range';
import { ModelSelectorModule } from '@shared/components/model-selector/model-selector.module';
import { QuillEditorComponent } from 'ngx-quill';
import { NgxMatDatetimepicker, NgxMatDatepickerInput } from '@ngxmc/datetime-picker';
import { MatNativeDateModule } from '@angular/material/core';
import { BadgeSelectComponent } from '@shared/components/badge-select/badge-select.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
    imports: [
        SharedModule,
        ReactiveFormsModule,
        LetDirective,
        PushPipe,
        FuseDateRangeModule,
        ModelSelectorModule,
        QuillEditorComponent,
        NgxMatDatetimepicker,
        NgxMatDatepickerInput,
        MatNativeDateModule,
        BadgeSelectComponent,
        ScrollingModule
    ],
    providers: [],
    declarations: [RequestCreateComponent],
    exports: [RequestCreateComponent]
})
export class RequestsCreateModule {}
